import React, { useEffect, useState } from 'react';
import { dropDownsList, staticDropDownsList } from '../../services/api/user';
import Select from 'react-select'; // Ensure you have installed react-select
import { useLanguage } from '../LanguageProvider/LanguageProvider ';

const SelectTypeDraft = ({ fieldKey, styles, theme, fieldValue, placeholder, setTabsWholeData, dropdownId, showEditIcon, fieldType, ukStateId, fieldDisabled }) => {
    const { language } = useLanguage();
    const [options, setOptions] = useState([]);
    const [errors, setErrors] = useState({}); // State for field-specific errors

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const formData = new FormData();
                formData.append("dropdown_id", dropdownId);
                const response = await dropDownsList(formData);
                const ParsedDropdownValue = JSON.parse(response?.data?.dropdown_values);
                const formattedOptions = ParsedDropdownValue?.items?.map((option, index) => ({
                    value: String(option?.id ? option?.id : `${index + 1}`), // Concatenate id with index
                    label: {
                        en: option?.name_en,
                        hi: option?.name_hi
                    }
                }));
                setOptions(formattedOptions);

                if (!response?.data?.dropdown_values || response?.data?.dropdown_values == "null") {
                    const staticFormData = new FormData();
                    staticFormData.append("title", response?.data?.name_en.toLowerCase());
                    const staticList = await staticDropDownsList(staticFormData);
                    let formattedStaticOptions = [];
                    if(response?.data?.name_en.toLowerCase() === "district"){
                        formattedStaticOptions = staticList?.data.filter((d) => d.state_id === ukStateId)?.map(option => ({
                            value: String(option.id),
                            label: {
                                en: option?.name_en,
                                hi: option?.name_hi
                            }
                        }));
                    } else {
                        formattedStaticOptions = staticList?.data?.map(option => ({
                            value: String(option.id),
                            label: {
                                en: option?.name_en,
                                hi: option?.name_hi
                            }
                        }));
                    }
                    setOptions(formattedStaticOptions);
                }
            } catch (error) {
                //console.error("Error fetching dropdown options:", error);
            }
        };

        fetchOptions();
    }, [dropdownId, language]);

    const option = options?.find(option => {
        return String(option?.value) === String(fieldValue) || option?.label.en === String(fieldValue) || option?.label.hi === String(fieldValue);
    });

    const handleBlur = () => {
        if (!fieldValue || fieldValue =="--" ) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldKey]: 'This field is required.' // Set error for the specific fieldKey
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [fieldKey]: '' // Clear error for the specific fieldKey
            }));
        }
    };

    return (
        <>
            {!showEditIcon ?
                <>
             
                    <Select
                        components={{
                            IndicatorSeparator: () => null,
                        }}
                        name={fieldKey}
                        styles={styles}
                        theme={theme}
                        options={options?.map((option) => ({
                            value: option?.value,
                            label: language ? option?.label?.hi : option?.label?.en, // Use Hindi or English label
                        }))}
                        placeholder={placeholder}
                        value={option ? { value: option?.value, label : option?.label[language ? "hi" : "en"] } : null}
                        onChange={(selected) => {
                            setTabsWholeData((prevData) => ({
                                ...prevData,
                                [fieldKey]: fieldType === "10" ? selected.value : selected.label
                            }));
                            setErrors((prevErrors) => ({
                                ...prevErrors,
                                [fieldKey]: '' // Clear error on selection
                            }));
                        }}
                        onBlur={handleBlur} // Trigger validation on blur   
                        isDisabled={fieldDisabled}
                    />
                    {errors[fieldKey] && <p className="validate-error">{errors[fieldKey]}</p>} {/* Display field-specific error */}
                </> :
                <p>{option ? option?.label[language ? "hi" : "en"] : null}</p>
                // <p>{options?.find(option => option?.label == fieldValue ? option?.label == fieldValue : option?.value == fieldValue)?.label ?? "--"}</p>
            }
        </>
    );
};

export default SelectTypeDraft;